import { apiPost } from './http'

export const signin = async request => apiPost('/auth/signin', request)

export const data = async request => apiPost('/auth/data', request, { auth: true })

export const updateUser = async request => apiPost('/auth/user', request, { auth: true })

export const contact = async request => apiPost('/auth/contact', request)

export const access = async request => apiPost('/auth/access', request)

export const forgot = async request => apiPost('/auth/forgot', request)

export const validate = async request => apiPost('/auth/validate', request)

export const change = async request => apiPost('/auth/change', request, { auth: true })
